import React, { useEffect, useRef } from 'react';
import { cn } from '../../lib/utils';

/**
 * Auto-growing textarea: expands to fit content, no character limit.
 */
const AutoTextarea = React.forwardRef(({ className, value, onChange, minRows = 6, ...props }, _ref) => {
  const innerRef = useRef(null);

  const resize = () => {
    const el = innerRef.current;
    if (!el) return;
    el.style.height = 'auto';
    el.style.height = `${el.scrollHeight}px`;
  };

  useEffect(() => { resize(); }, [value]);
  useEffect(() => {
    // Initial sizing
    resize();
    // Resize on window resize
    const onR = () => resize();
    window.addEventListener('resize', onR);
    return () => window.removeEventListener('resize', onR);
  }, []);

  return (
    <textarea
      ref={innerRef}
      rows={minRows}
      value={value}
      onChange={(e) => { onChange?.(e); resize(); }}
      className={cn(
        'flex w-full rounded-md border border-input bg-background px-3 py-2 text-sm ring-offset-background placeholder:text-muted-foreground focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-50 overflow-hidden',
        className
      )}
      {...props}
    />
  );
});
AutoTextarea.displayName = 'AutoTextarea';

export { AutoTextarea };
